import type { FC } from 'react';

import { TooltipArrow } from './tooltip-arrow';
import { TooltipContent } from './tooltip-content';
import { TooltipPortal } from './tooltip-portal';
import { TooltipRoot } from './tooltip-root';
import { TooltipTrigger } from './tooltip-trigger';
import type { TooltipPropsInterface } from './types/tooltip.types';

/**
 * @since 7.0.0
 */
export const Tooltip: FC<TooltipPropsInterface> & {
  Root: typeof TooltipRoot;
  Trigger: typeof TooltipTrigger;
  Portal: typeof TooltipPortal;
  Content: typeof TooltipContent;
  Arrow: typeof TooltipArrow;
} = (props: TooltipPropsInterface) => {
  const {
    children,
    content,
    trigger,
    css: cssProp,
    focusManagerProps = {},
    className,
    style,
    portalId,
    portalRoot,
    portalPreserveTabOrder,
    ...rest
  } = props;
  return (
    <Tooltip.Root {...rest}>
      <Tooltip.Trigger>{trigger}</Tooltip.Trigger>
      <Tooltip.Portal id={portalId} root={portalRoot} preserveTabOrder={portalPreserveTabOrder}>
        <Tooltip.Content
          css={cssProp}
          style={style}
          className={className}
          focusManagerProps={focusManagerProps}
        >
          {content || children}
          <Tooltip.Arrow />
        </Tooltip.Content>
      </Tooltip.Portal>
    </Tooltip.Root>
  );
};

Tooltip.displayName = 'Tooltip';

Tooltip.Root = TooltipRoot;
Tooltip.Trigger = TooltipTrigger;
Tooltip.Portal = TooltipPortal;
Tooltip.Content = TooltipContent;
Tooltip.Arrow = TooltipArrow;
